import Vue from 'vue'
import Vuex from 'vuex'
import { getUser } from '../utils/auth.js'
import { getCusip, getProperties, getSummaryData, getSummaryData2 } from '../utils/cusip.js'
import { parseGeoJSON, getIsochrones, handleLocationData } from '../utils/map.js'
import { risQScores } from '../utils/risq_score.js'
import { SocialScores } from '../utils/social_score.js'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    isAuthenticated: function(state) {
      return state.user != null
    },
    isClimate: function(state) {
      return state.mapMode == 'rscore'
    },
    summaryScoreLabel: function(state, getters) {
      return getters.isClimate ? 'ICE Climate Risk Score' : 'Social Impact Score'
    },
    featuredSubscoreTypes: function(state,getters) {
      if (state.mapMetric == 'social_impact') {
        return []
      } else if (getters.isClimate) {
        return risQScores.subscoreTypes
      } else {
        return [`${state.mapMetric}_score`]
      }
    },
    isochroneScores: function(state) {
      return (state.mapMode == 'rscore') ? state.isochroneRScores : state.isochroneSScores
    },
    customLocationUploadLimit: function(state) {
      console.log(`state.user ${state.user}, ${state.user.trial}`)
      if(state.user.trial) {
        return 1100 /* 50 */
      } else if (state.user) {
        return 1100
      } else {
        return 0
      }
    }
  },

  state: {
    appName:"MBS ESG Data UI",
    navMini: false,
    user: null,
    currentCusip: null,
    currentCusipData: null,
    summaryData: null,
    propertyData: null,
    loading: false,
    collectionToLoad: null,
    mapPoints: null,
    summaryRscores: null,
    propertyRscores: null,
    selectedProperty: null,
    driveTimeOptions: [1, 6, 15, 30],
    drive_time: 6,
    showDriveTimeTable: false,
    isochrones: null,
    isochroneRScores: {},
    isochroneSScores: {},
    isochroneData: {},
    about: [],
    labels: {},
    focusedRadius: 6,
    customLocationListRefreshedAt: null,
    myLocationGroups: [],
    noMyLocationGroups: false,
    noSharedLocationGroups: false,
    sharedLocationGroups: [],
    locationScope: 'mine',
    collectionListRefreshedAt: null,
    collectionItems: [],
    collection: {},
    collectionId: '',
    noMyCollections: false,
    noSharedCollections: false,
    myCollections: [],
    sharedCollections: [],
    collectionScope: 'mine',

    uploadedLocation: null,
    colToGenerate: '',
    mapMode: 'rscore',
    mapMetric: 'risq',
    tooltip: {
        nudgeTop:"20",
        nudgeRight:"18"
    },
    uploadSuccess: false,
    startGenerationCheck: false,
    //array of arrays of form [[id, name], ... [id, name]]:
    justGenerated:[],
    /* powerpoint state */
    powerpointDataToGenerate: ['propertyName', 'driveTime', 'climateMapUrl', 'socialMapUrl', 'gaugeUrls', 'gaugeDimensions', 'socialImpactUrl', 'subscoreUrl', 'socialImpactDimensions', 'subscoreDimensions'],
    startPowerpointGeneration: false,
    powerpointData: {}
  },
  mutations: {
    updateState(state, keypair) {
      state[keypair[0]] = keypair[1]
    }
  },
  actions: {
    setMapMetric(context,payload) {
      if (['risq','hurricane','flood','wildfire'].includes(payload)) {
        context.commit('updateState',['mapMode','rscore'])
      } else {
        context.commit('updateState',['mapMode','sscore'])
      }
      context.commit('updateState',['mapMetric',payload])
    },
    refreshCusipData(context,payload) {
      if (context.state.currentCusip) {
        context.dispatch('getCusipData', this.state.currentCusip)
      }
    },
    updateState(context, payload) {
      return new Promise((resolve) => {
        context.commit('updateState', payload)
        resolve(payload)
      })
    },
    logout(context) {
      context.commit('updateState', ['user', null]);

    },
    setUserFromObject(context,payload) {
      return new Promise((resolve, reject) => {
        context.commit('updateState', ['user', payload])
        resolve()
      })
    },
    setUserFromServer(context, payload) {
      return getUser().then(response => {
        if (response && response.data && response.data.cookie) {
          context.commit('updateState', ['user', response.data.cookie.user])
          context.commit('updateState', ['about', response.data.about])
        } else if (response && response.data && response.data.user) {
            context.commit('updateState', ['user', response.data.user])
            context.commit('updateState', ['about', response.data.about])
        } else {
            console.warn("User could not be read from getUser() response")
        }
      })
    },
    selectPropertyById(context,payload) {
      const pData = context.state.mapPoints.find(item => item.properties.id == payload)
      context.dispatch('updateState', ['selectedProperty', pData.properties]).then(resolution => {
        context.dispatch('fetchIsochrones', pData)
      })
    },
    fetchIsochrones(context, feature) {
      return getIsochrones(feature).then(response => {
        parseGeoJSON(response.data, 'isochrone').then(parsedResults => {
          context.commit('updateState', ['isochrones', parsedResults])
        }).then(res => {
          let newRscores = {}
          let newSscores = {}
          let newData = {}
          response.data.forEach(item => {
            newRscores[item.drive_time] =  new risQScores(item.risq_score, item.hurricane_score, item.flood_score, item.wildfire_score, item.wt)
            newSscores[item.drive_time] =  new SocialScores(item)
            newData[item.drive_time] = item
          })
          context.commit('updateState', ['isochroneRScores', newRscores])
          context.commit('updateState', ['isochroneSScores', newSscores])
          context.commit('updateState', ['isochroneData', newData])
          /* not entirely sure why the table is blank the first time it's drawn, but I know that unless we do this using the vuex state, it doesn't render data in the table the first time */
          context.commit('updateState', ['showDriveTimeTable', true])
        })
      })
    },
    clearSelectedProperty(context) {
      // context.commit('updateState', ['isochroneScores', {}])
      ['selectedProperty','isochrones','isochroneRScores','isochroneSScores','isochroneData'].forEach(stateVariable => {
        context.commit('updateState', [stateVariable, null])
      })
      context.commit('updateState', ['showDriveTimeTable', false])
    },
    getCusipData(context, payload) {
      ['currentCusip','currentCusipData','propertyRscores','selectedProperty','mapPoints','summaryRscores','propertyData','summaryData'].forEach(stateVariable => {
        context.commit('updateState', [stateVariable, null])
      })
      context.commit('updateState', ['loading', true])
      return getCusip(payload).then(response => {
        if (response && response.data) {
          context.commit('updateState', ['currentCusipData', response.data])
          context.commit('updateState', ['currentCusip', response.data.cusip])
          if (response.data && response.data.security_type === 'cmbs') {
            getProperties(response.data.cusip, context.state.drive_time).then(propResponse => {
              handleLocationData(propResponse.data, this)
            })
            getSummaryData(response.data.cusip,context.state.drive_time).then(summResponse => {
              context.commit('updateState', ['summaryData', summResponse.data])
              context.commit('updateState', ['summaryRscores', new risQScores(summResponse.data['risq_score'], summResponse.data['hurricane_score'], summResponse.data['flood_score'], summResponse.data['wildfire_score'])])
            })
          } else if (response.data && response.data.security_type !== 'cmbs') {
            getSummaryData2(response.data.cusip).then(summResponse => {
              context.commit('updateState', ['summaryData', summResponse.data])
              context.commit('updateState', ['summaryRscores', new risQScores(summResponse.data['risq_score'], summResponse.data['hurricane_score'], summResponse.data['flood_score'], summResponse.data['wildfire_score'])])
            })
          } else {
            console.log(response.data)
          }
        }
      })
    },
    initLabels(context,payload) {
      let label = {}
      label['risq_score'] = 'ICE Climate Risk Score'
      label['hurricane_score'] = 'Hurricane Score'
      label['flood_score'] = 'Flood Score'
      label['wildfire_score'] = 'Wildfire Score'
      label['hurricane'] = 'Hurricane Score'
      label['flood'] = 'Flood Score'
      label['wildfire'] = 'Wildfire Score'
      label['pct_risq_score_gte_30'] = 'Percentage of UPB with ICE Climate Risk Score >=3'
      label['pct_risq_score_gte_40'] = 'Percentage of UPB with ICE Climate Risk Score >= 4'
      label['pct_risq_score_gte_45'] = 'Percentage of UPB with Hurricane Score >=3'
      label['pct_hurricane_score_gte_30'] = 'Percentage of UPB with ICE Climate Risk Score >= 4.5'
      label['pct_hurricane_score_gte_40'] = 'Percentage of UPB with Hurricane Score >=4'
      label['pct_hurricane_score_gte_45'] = 'Percentage of UPB with Hurricane Score >= 4.5'
      label['pct_flood_score_gte_30'] = 'Percentage of UPB with Flood Score >=3'
      label['pct_flood_score_gte_40'] = 'Percentage of UPB with Flood Score >=4'
      label['pct_flood_score_gte_45'] = 'Percentage of UPB with Flood Score >=4.5'
      label['pct_wildfire_score_gte_30'] = 'Percentage of UPB with Wildfire Score >=3'
      label['pct_wildfire_score_gte_40'] = 'Percentage of UPB with Wildfire Score >= 4'
      label['pct_wildfire_score_gte_45'] = 'Percentage of UPB with Wildfire Score >= 4.5'
      label['combined_totaldamage_fullbasis_base_current'] = 'Combined Climate - Total Damage - Full Basis - Base - Current Year'
      label['combined_totaldamage_fullbasis_rcp45_10yr'] = 'Combined Climate - Total Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['combined_totaldamage_fullbasis_rcp45_30yr'] = 'Combined Climate - Total Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['combined_totaldamage_fullbasis_rcp85_10yr'] = 'Combined Climate - Total Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['combined_totaldamage_fullbasis_rcp85_30yr'] = 'Combined Climate - Total Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['hurricaneflood_totaldamage_fullbasis_base_current'] = 'Hurricane Flood - Total Damage - Full Basis - Base - Current Year'
      label['hurricaneflood_totaldamage_fullbasis_rcp45_10yr'] = 'Hurricane Flood - Total Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['hurricaneflood_totaldamage_fullbasis_rcp45_30yr'] = 'Hurricane Flood - Total Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['hurricaneflood_totaldamage_fullbasis_rcp85_10yr'] = 'Hurricane Flood - Total Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['hurricaneflood_totaldamage_fullbasis_rcp85_30yr'] = 'Hurricane Flood - Total Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['hurricaneflood_sfhadamage_fullbasis_base_current'] = 'Hurricane Flood - SFHA Damage - Full Basis - Base - Current Year'
      label['hurricaneflood_sfhadamage_fullbasis_rcp45_10yr'] = 'Hurricane Flood - SFHA Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['hurricaneflood_sfhadamage_fullbasis_rcp45_30yr'] = 'Hurricane Flood - SFHA Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['hurricaneflood_sfhadamage_fullbasis_rcp85_10yr'] = 'Hurricane Flood - SFHA Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['hurricaneflood_sfhadamage_fullbasis_rcp85_30yr'] = 'Hurricane Flood - SFHA Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['stormsurge_totaldamage_fullbasis_base_current'] = 'Storm Surge - Total Damage - Full Basis - Base - Current Year'
      label['stormsurge_totaldamage_fullbasis_rcp45_10yr'] = 'Storm Surge - Total Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['stormsurge_totaldamage_fullbasis_rcp45_30yr'] = 'Storm Surge - Total Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['stormsurge_totaldamage_fullbasis_rcp85_10yr'] = 'Storm Surge - Total Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['stormsurge_totaldamage_fullbasis_rcp85_30yr'] = 'Storm Surge - Total Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['stormsurge_sfhadamage_fullbasis_base_current'] = 'Storm Surge - SFHA Damage - Full Basis - Base - Current Year'
      label['stormsurge_sfhadamage_fullbasis_rcp45_10yr'] = 'Storm Surge - SFHA Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['stormsurge_sfhadamage_fullbasis_rcp45_30yr'] = 'Storm Surge - SFHA Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['stormsurge_sfhadamage_fullbasis_rcp85_10yr'] = 'Storm Surge - SFHA Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['stormsurge_sfhadamage_fullbasis_rcp85_30yr'] = 'Storm Surge - SFHA Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['hurricanewind_totaldamage_fullbasis_base_current'] = 'Hurricane Wind - Total Damage - Full Basis - Base - Current Year'
      label['hurricanewind_totaldamage_fullbasis_rcp45_10yr'] = 'Hurricane Wind - Total Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['hurricanewind_totaldamage_fullbasis_rcp45_30yr'] = 'Hurricane Wind - Total Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['hurricanewind_totaldamage_fullbasis_rcp85_10yr'] = 'Hurricane Wind - Total Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['hurricanewind_totaldamage_fullbasis_rcp85_30yr'] = 'Hurricane Wind - Total Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['inlandflood_totaldamage_fullbasis_base_current'] = 'Inland Flood - Total Damage - Full Basis - Base - Current Year'
      label['inlandflood_totaldamage_fullbasis_rcp45_10yr'] = 'Inland Flood - Total Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['inlandflood_totaldamage_fullbasis_rcp45_30yr'] = 'Inland Flood - Total Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['inlandflood_totaldamage_fullbasis_rcp85_10yr'] = 'Inland Flood - Total Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['inlandflood_totaldamage_fullbasis_rcp85_30yr'] = 'Inland Flood - Total Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['inlandflood_sfhadamage_fullbasis_base_current'] = 'Inland Flood - SFHA Damage - Full Basis - Base - Current Year'
      label['inlandflood_sfhadamage_fullbasis_rcp45_10yr'] = 'Inland Flood - SFHA Damage - Full Basis - RCP4.5 - 10 Years Out'
      label['inlandflood_sfhadamage_fullbasis_rcp45_30yr'] = 'Inland Flood - SFHA Damage - Full Basis - RCP4.5 - 30 Years Out'
      label['inlandflood_sfhadamage_fullbasis_rcp85_10yr'] = 'Inland Flood - SFHA Damage - Full Basis - RCP8.5 - 10 Years Out'
      label['inlandflood_sfhadamage_fullbasis_rcp85_30yr'] = 'Inland Flood - SFHA Damage - Full Basis - RCP8.5 - 30 Years Out'
      label['coastalflood_totaldamage_fullbasis_base_current'] = 'Coastal Flood - Total Damage - Full Basis - Base - Current Year'
      label['coastalflood_totaldamage_fullbasis_base_10yr'] = 'Coastal Flood - Total Damage - Full Basis - Base - 10 Years Out'
      label['coastalflood_sfhadamage_fullbasis_base_current'] = 'Coastal Flood - SFHA Damage - Full Basis - Base - Current Year'
      label['coastalflood_sfhadamage_fullbasis_base_10yr'] = 'Coastal Flood - SFHA Damage - Full Basis - Base - 10 Years Out'
      label['pct_totalflood_likely_uninsured'] = 'Percentage of total flood risk outside of FEMA SFHA 100-year insurance zone (likely uninsured)'
      label['wildfire_totaldamage_fullbasis_base_current'] = 'Wildfire - Total Damage - Full Basis - Base - Current Year'
      label['wildfire_totaldamage_fullbasis_rcp45_10yr'] = 'Wildfire - Total Damage - Full Basis - RCP45 - 10 Years Out'
      label['wildfire_totaldamage_fullbasis_rcp45_30yr'] = 'Wildfire - Total Damage - Full Basis - RCP45 - 30 Years Out'
      label['wildfire_totaldamage_fullbasis_rcp85_10yr'] = 'Wildfire - Total Damage - Full Basis - RCP85 - 10 Years Out'
      label['wildfire_totaldamage_fullbasis_rcp85_30yr'] = 'Wildfire - Total Damage - Full Basis - RCP85 - 30 Years Out'
      label['social_impact_score'] = 'Social Impact Score'
      label['low_affluence_score'] = 'Low Affluence Score'
      label['low_education_score'] = 'Low Educational Attainment Score'
      label['low_prestige_employment_score'] = 'Low Prestige Employment Score'
      label['health_obstacle_score'] = 'Persistent Health Obstacles Score'
      label['poverty_concentration_score'] = 'Poverty Concentration Score'
      label['pct_income_on_housing_score'] = 'Percent of Income Spent on Housing Score'
      label['minority_score'] = 'Nonwhite/Minority Population Score'
      label['pct_top_quartile_social_impact_score'] = 'Pct UPB in Top Quartile: Social Impact Score'
      label['pct_low_quartile_social_impact_score'] = 'Pct UPB in Low Quartile: Social Impact Score'
      label['pct_top_quartile_low_affluence_score'] = 'Pct UPB in Top Quartile: Low Affluence Score'
      label['pct_low_quartile_low_affluence_score'] = 'Pct UPB in Low Quartile: Low Affluence Score'
      label['pct_top_quartile_low_education_score'] = 'Pct UPB in Top Quartile: Low Educational Attainment Score'
      label['pct_low_quartile_low_education_score'] = 'Pct UPB in Low Quartile: Low Educational Attainment Score'
      label['pct_top_quartile_low_prestige_employment_score'] = 'Pct UPB in Top Quartile: Low Prestige Employment Score'
      label['pct_low_quartile_low_prestige_employment_score'] = 'Pct UPB in Low Quartile: Low Prestige Employment Score'
      label['pct_top_quartile_health_obstacle_score'] = 'Pct UPB in Top Quartile: Persistent Health Obstacles Score'
      label['pct_low_quartile_health_obstacle_score'] = 'Pct UPB in Low Quartile: Persistent Health Obstacles Score'
      label['pct_top_quartile_poverty_concentration_score'] = 'Pct UPB in Top Quartile: Poverty Concentration'
      label['pct_low_quartile_poverty_concentration_score'] = 'Pct UPB in Low Quartile: Poverty Concentration'
      label['pct_top_quartile_pct_income_on_housing_score'] = 'Pct UPB in Top Quartile: Percent of Income Spent on Housing Score'
      label['pct_low_quartile_pct_income_on_housing_score'] = 'Pct UPB in Low Quartile: Percent of Income Spent on Housing Score'
      label['pct_top_quartile_minority_score'] = 'Pct UPB in Top Quartile: Nonwhite/Minority Population Score'
      label['pct_low_quartile_minority_score'] = 'Pct UPB in Low Quartile: Nonwhite/Minority Population Score'
      label['ed_pct_25up_less_than_high_school'] = 'Less Than High School Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_high_school_GED_or_equiv'] = 'GED or Equivalent Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_some_college'] = 'Some College Experience Holders among People 25 years and older (%)'
      label['ed_pct_25up_assoc_degree'] = 'Associates Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_bachelor_degree'] = 'Bachelor Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_master_degree'] = 'Masters Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_professional_degree'] = 'Professional Degree Holders among People 25 years and older (%)'
      label['ed_pct_25up_doctorate_degree'] = 'Doctorate Degree Holders among People 25 years and older (%)'
      label['per_capita_income'] = 'Per Capita Income ($)'
      label['median_household_income'] = 'Median Household Income ($)'
      label['median_household_discretionary_income'] = 'Median Household Discretionary Income ($)'
      label['gini_index'] = 'Local Gini Index'
      label['median_monthly_housing_costs'] = 'Median Monthly Housing Costs ($)'
      label['pct_stressed_renters_income_lte35k'] = 'Stressed Renters (40%+ rent-to-income) with Less than $35k Income (%)'
      label['pct_stressed_renters_income_35to75k'] = 'Stressed Renters (40%+ rent-to-income) with $35k to $75k Income (%)'
      label['median_year_housing_built'] = 'Median Year Housing Built'
      label['pct_w_health_insurance_coverage'] = 'Population with Health Insurance (%)'
      label['pct_high_income_young_home_owners'] = 'High Income Young Home Owners (%)'
      label['pct_commute_lte20mins'] = 'Commute to Work <= 20 Minutes (%)'
      label['pct_commute_20to40mins'] = 'Commute to Work 20-40 Minutes (%)'
      label['pct_commute_gte40mins'] = 'Commute to Work >=40 Minutes (%)'
      label['pct_stressed_renters_income_gte75k'] = 'Stressed Renters (40%+ rent-to-income) with greater than $75k Income (%)'
      label['pct_stressed_renters_income_allbrackets'] = 'Stressed Renters (40%+ rent-to-income) (%)'
      label['pct_under_poverty_line'] = 'Below Poverty Line (%)'
      label['pct_worktrans_cartruckvan'] = 'Workers Commute Using a Car Truck or Van (%)'
      label['pct_worktrans_publictrans'] = 'Workers Commute Using Public Transit (%)'
      label['pct_worktrans_walkbike'] = 'Workers Commute by Bike or on Foot (%)'
      label['pct_worktrans_athome'] = 'Workers who Work From Home (%)'
      label['pct_kids_under_18'] = 'Children Under 18 (%)'
      label['zsc__highaffluence_index'] = 'Z-Score: High Affluence Index'
      label['zsc__higheducation_index'] = 'Z-Score: High Education Index'
      label['zsc__highpctseniors_index'] = 'Z-Score: Senior Citizen Concentration Index'
      label['zsc__concentratedpoverty_index'] = 'Z-Score: Concentrated Poverty Index'
      label['zsc__pct_below_poverty_ratio'] = 'Z-Score: Percentage Below Poverty Ratio'
      label['zsc__pct_with_health_insurance'] = 'Z-Score: Population Percentage with Health Insurance'
      label['pct_rac_CNS01_naics11_agric'] = '% jobs in NAICS sector 11 (Agriculture, Forestry, Fishing and Hunting) - Residence'
      label['pct_rac_CNS02_naics21_miningoilgas'] = '% jobs in NAICS sector 21 (Mining, Quarrying, and Oil and Gas Extraction) - Residence'
      label['pct_rac_CNS03_naics22_utilities'] = '% jobs in NAICS sector 22 (Utilities) - Residence'
      label['pct_rac_CNS04_naics23_construc'] = '% jobs in NAICS sector 23 (Construction) - Residence'
      label['pct_rac_CNS05_naics3133_manuf'] = '% jobs in NAICS sector 31-33 (Manufacturing) - Residence'
      label['pct_rac_CNS06_naics42_wholesale'] = '% jobs in NAICS sector 42 (Wholesale Trade) - Residence'
      label['pct_rac_CNS07_naics4445_retail'] = '% jobs in NAICS sector 44-45 (Retail Trade) - Residence'
      label['pct_rac_CNS08_naics4849_transpowarehouse'] = '% jobs in NAICS sector 48-49 (Transportation and Warehousing) - Residence'
      label['pct_rac_CNS09_naics51_information'] = '% jobs in NAICS sector 51 (Information) - Residence'
      label['pct_rac_CNS10_naics52_financinsur'] = '% jobs in NAICS sector 52 (Finance and Insurance) - Residence'
      label['pct_rac_CNS11_naics53_realestate'] = '% jobs in NAICS sector 53 (Real Estate and Rental and Leasing) - Residence'
      label['pct_rac_CNS12_naics54_profscitechsvcs'] = '% jobs in NAICS sector 54 (Professional, Scientific, and Technical Services) - Residence'
      label['pct_rac_CNS13_naics55_managementsvcs'] = '% jobs in NAICS sector 55 (Management of Companies and Enterprises) - Residence'
      label['pct_rac_CNS14_naics56_adminsupportsvcs'] = '% jobs in NAICS sector 56 (Administrative and Support and Waste Management and Remediation Services) - Residence'
      label['pct_rac_CNS15_naics61_education'] = '% jobs in NAICS sector 61 (Educational Services) - Residence'
      label['pct_rac_CNS16_naics62_healthcare'] = '% jobs in NAICS sector 62 (Health Care and Social Assistance) - Residence'
      label['pct_rac_CNS17_naics71_artsentertain'] = '% jobs in NAICS sector 71 (Arts, Entertainment, and Recreation) - Residence'
      label['pct_rac_CNS18_naics72_hotelsfoodsvcs'] = '% jobs in NAICS sector 72 (Accommodation and Food Services) - Residence'
      label['pct_rac_CNS19_naics81_othersvcs'] = '% jobs in NAICS sector 81 (Other Services [except Public Administration]) - Residence'
      label['pct_rac_CNS20_naics92_publicadmin'] = '% jobs in NAICS sector 92 (Public Administration) - Residence'
      label['hpa_lag_ratio__current__q50__implied_home_value__space'] = 'HPA Ratio: Origination Implied Home Value over Current Median Home Value (Comps Closer in Space)'
      label['hpa_lag_ratio__current__q50__implied_home_value__time'] = 'HPA Ratio: Origination Implied Home Value over Current Median Home Value (Comps Closer in Time)'
      label['hpa_lag_ratio__lag12__q50__implied_home_value__space'] = 'HPA Ratio: Origination Implied Home Value over 12-Month-Lagged Median Home Value (Comps Closer in Space)'
      label['hpa_lag_ratio__lag12__q50__implied_home_value__time'] = 'HPA Ratio: Origination Implied Home Value over 12-Month-Lagged Median Home Value (Comps Closer in Time)'
      label['hpa_lag_ratio__lag24__q50__implied_home_value__space'] = 'HPA Ratio: Origination Implied Home Value over 24-Month-Lagged Median Home Value (Comps Closer in Space)'
      label['hpa_lag_ratio__lag24__q50__implied_home_value__time'] = 'HPA Ratio: Origination Implied Home Value over 24-Month-Lagged Median Home Value (Comps Closer in Time)'
      label['hpa_lag_ratio__lag36__q50__implied_home_value__space'] = 'HPA Ratio: Origination Implied Home Value over 36-Month-Lagged Median Home Value (Comps Closer in Space)'
      label['hpa_lag_ratio__lag36__q50__implied_home_value__time'] = 'HPA Ratio: Origination Implied Home Value over 36-Month-Lagged Median Home Value (Comps Closer in Time)'
      label['hpa_lag_ratio__lag60__q50__implied_home_value__space'] = 'HPA Ratio: Origination Implied Home Value over 60-Month-Lagged Median Home Value (Comps Closer in Space)'
      label['hpa_lag_ratio__lag60__q50__implied_home_value__time'] = 'HPA Ratio: Origination Implied Home Value over 60-Month-Lagged Median Home Value (Comps Closer in Time)'
      label['hpa_zsc__factor__implied_home_value__space'] = 'Z-Score at Factor Date: Loan Implied Home Value Against Local Comp Mean/Standard Deviation (Comps Closer in Space)'
      label['hpa_zsc__factor__implied_home_value__time'] = 'Z-Score at Factor Date: Loan Implied Home Value Against Local Comp Mean/Standard Deviation (Comps Closer in Time)'
      label['hpa_zsc__orig__implied_home_value__space'] = 'Z-Score at Origination: Loan Implied Home Value Against Local Comp Mean/Standard Deviation (Comps Closer in Space)'
      label['hpa_zsc__orig__implied_home_value__time'] = 'Z-Score at Origination: Loan Implied Home Value Against Local Comp Mean/Standard Deviation (Comps Closer in Time)'
      label['pct_change_odds__context_factors'] = 'Percent Change in Baseline Prepayment Odds: Combined Contextual Factors'
      label['pct_change_odds__loan_factors'] = 'Percent Change in Baseline Prepayment Odds: Combined Loan-Level Factors'
      label['pct_change_odds__loan_pct_upb_remaining'] = 'Percent Change in Baseline Prepayment Odds: Percent UPB Remaining (Current UPB / Original Loan Amount)'
      label['pct_change_odds__margef__affluence__pc1'] = 'Percent Change in Baseline Prepayment Odds: Affluence Index'
      label['pct_change_odds__margef__age__pc1'] = 'Percent Change in Baseline Prepayment Odds: High Concentration of Seniors Index'
      label['pct_change_odds__margef__fmv_PC1'] = 'Percent Change in Baseline Prepayment Odds: Absolute Loan Overpricing '
      label['pct_change_odds__margef__fmv_PC2'] = 'Percent Change in Baseline Prepayment Odds: Borrower Insensitivity to Long-Duration Loan Overpricing'
      label['pct_change_odds__margef__ratio_loanpmt_medmonhouscost'] = 'Percent Change in Baseline Prepayment Odds: Localized P/I Loan Payment Affordability'
      label['pct_change_odds__margef__zsc_diff_hpa_bnd3'] = 'Percent Change in Baseline Prepayment Odds: Implied Relative Home Price Appreciation Since Origination'
      label['pct_change_odds__margef_fmv_acceleration'] = 'Percent Change in Baseline Prepayment Odds: Index of Accelerating Overpricing'
      label['rategap_accumbps_lag_1to12'] = 'Fair Market Value Spreads: Accumulated Sum (Basis Points) of 1-3 Months Preceding Factor Date'
      label['rategap_accumbps_lag_1to24'] = 'Fair Market Value Spreads: Accumulated Sum (Basis Points) of 1-6 Months Preceding Factor Date'
      label['rategap_accumbps_lag_1to3'] = 'Fair Market Value Spreads: Accumulated Sum (Basis Points) of 1-12 Months Preceding Factor Date'
      label['rategap_accumbps_lag_1to6'] = 'Fair Market Value Spreads: Accumulated Sum (Basis Points) of 1-24 Months Preceding Factor Date'
      label['zsc__housing_affordability'] = 'Z-Score: Localized Housing Market Affordability (High = Less Affordable)'
      label['zsc__loanpayment_affordability'] = 'Z-Score: Localized P/I Loan Payment Affordability (High = Less Affordable)'
      label['zsc__prepay_relative_risk__universe'] = 'Prepayment Relative Risk Score (Z-Score over Active Loans at Factor Date)'
      context.commit('updateState',['labels',label])
    }
  },
  modules: {
  }
})
